import { useEffect, useRef, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import moment from 'moment';

import { ModelOfPeople, ModelOfPeopleForm } from 'src/database';

import api from 'src/services/api';
import { useAuth } from 'src/contexts/auth';

const initialValuesOfAgencyPeople = {
	ORGAO: '',
	ORGAOUNIDADE: '',
	CARGO: '',
	NOME: '',
	DATANASCIMENTO: '',
	CPF: '',
};
export const useListAgencyPeoplesController = () => {
	const [AgencyPeoplesData, setAgencyPeoplesData] = useState<ModelOfPeople[]>([]);
	const [selectedAgencyPeople, setSelectedAgencyPeople] = useState<ModelOfPeople>(initialValuesOfAgencyPeople);
	const [loading, setLoading] = useState(false);
	const [loadingRows, setLoadingRows] = useState(false);
	const [loadingEdit, setLoadingEdit] = useState(false);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	const [rows, setRows] = useState(0);
	const [maxData, setMaxData] = useState(false);

	const { userAgencyId } = useAuth();
	const toast: any = useRef();

	const getAgencyPeoples = () => {
		if (rows === 0) {
			setLoading(true);
		} else {
			setLoadingRows(true);
		}
		api.post('/agencys/people2', { ORGAO: userAgencyId, ROW: rows })
			.then(response => {
				if (response.status === 204) {
					setMaxData(true);
					setLoading(false);
					setLoadingRows(false);
				} else {
					setAgencyPeoplesData(AgencyPeoplesData.concat(response.data));
					setLoading(false);
					setLoadingRows(false);
				}
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
				setLoadingRows(false);
			});
	};

	const removeAgencyPeople = (AgencyPeople: ModelOfPeople) => {
		setLoading(true);
		api.delete(`people/${AgencyPeople.ID}`)
			.then(response => {
				const newList = AgencyPeoplesData.filter(person => person.ID !== response.data.ID);
				setAgencyPeoplesData(newList);
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'A pessoa foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getAgencyPeoples();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editAgencyPeople = (AgencyPeople: ModelOfPeopleForm) => {
		setLoadingEdit(true);

		const editedAgencyPeople: ModelOfPeople = {
			ORGAOUNIDADE: AgencyPeople.ORGAOUNIDADE,
			CARGO: AgencyPeople.CARGO,
			NOME: AgencyPeople.NOME,
			CPF: AgencyPeople.CPF,
			ORGAO: userAgencyId,
			DATANASCIMENTO: moment(AgencyPeople.DATANASCIMENTO, 'DD/MM/YYYY')
				.toDate()
				.toLocaleDateString('en', { year: 'numeric', month: '2-digit', day: '2-digit' }),
		};

		api.post(`people/${selectedAgencyPeople?.ID}/${selectedAgencyPeople.ID_ORGAOUNIDADEPESSOA}`, editedAgencyPeople)
			.then(() => {
				// getAgencyPeoples();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'A pessoa foi editada com sucesso!',
					life: 5000,
				});
				setTimeout(() => {
					window.location.reload();
				}, 1500);
			})
			.catch(err => {
				getAgencyPeoples();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getAgencyPeoples();
	}, [rows]);

	const openDeleteDialog = (AgencyPeople: ModelOfPeople) => {
		setDeleteDialog(true);
		setSelectedAgencyPeople(AgencyPeople);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (AgencyPeople: ModelOfPeople) => {
		setEditDialog(true);
		setSelectedAgencyPeople(AgencyPeople);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfPeopleForm>({
		initialValues: {
			ORGAO: '',
			ORGAOUNIDADE: '',
			CARGO: '',
			NOME: '',
			DATANASCIMENTO: '',
			CPF: '',
		},
		onSubmit: values => editAgencyPeople(values),
	});

	return {
		getAgencyPeopleListController: {
			formik,
			AgencyPeoplesData,
			selectedAgencyPeople,
			loading,
			loadingRows,
			deleteDialog,
			editDialog,
			loadingEdit,
			toast,
			rows,
			maxData,
		},
		handleAgencyPeopleListController: {
			removeAgencyPeople,
			editAgencyPeople,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
			setRows,
		},
	};
};
